<template>
    <div>
        <table class="table table-bordered table-hover promotions-table ">
            <thead>
            <tr>
                <table-head-with-sort :text="$t('PRODUCTS.name')"
                                      :showControls="false"/>
                <table-head-with-sort :text="$t('COMMON.type')"
                                      :sortType="'price'"/>
                <table-head-with-sort :text="$t('COMMON.price')"
                                      :sortType="'active'" v-if="!history"/>
                <table-head-with-sort :text="$t('COMMON.active')"
                                      :showControls="false" />
                <table-head-with-sort :text="$t('UI.remove')"
                                      :showControls="false"
                                      v-if="$route.name === 'FastEdit'" />
            </tr>
            </thead>
            <tbody>
            <tr v-for="(fee, index) in fees"
                :key="`fee-${fee.id}-${index}`"
                >
                <!-- @click="feeTableClicked(fee)" -->
                <td>{{fee.name}}</td>
                <td>
                    {{fee.type}}
                </td>
                <td>
                    <vue-numeric :decimal-separator="decimalSeparator"
                                 :separator="separator"
                                 :currency="symbol"
                                 currency-symbol-position="suffix"
                                 :read-only="true"
                                 :precision="2"
                                 :value="fee.price"></vue-numeric>
                </td>
                <td v-if="!history">
                    <div v-if="$route.name !== 'FastEdit'">{{fee.active ? $t('COMMON.active') : $t('COMMON.inactive')}}</div>
                    <vue-checkbox-toggle
                        v-else
                        ref="checkbox"
                        v-model="fee.active"
                        :value="fee.active"
                        @focus="fee.focused=true"
                        @clicked="activateFee(fee)"
                    >
                    </vue-checkbox-toggle>
                </td>
                <td v-if="$route.name === 'FastEdit'">
                    <cph-button @clicked="removeFee(fee)"
                                :buttonText="'Remove'"
                                :classList="'btn btn-warning btn-sm'">
                    </cph-button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import Table from '../../../components/Panel/Table/Table.vue';
import VueCheckboxToggle from '../../../components/Shared/Toggler';
import CphButton from '../../../components/Shared/UI/Button/CphButton';
import VueNumeric from 'vue-numeric';
import TableHeadWithSort from '../../../components/Shared/UI/Table/TableHeadWithSort';

export default {
    name: 'fee-table',
    components: {
        'vue-table': Table,
        VueCheckboxToggle,
        CphButton,
        VueNumeric,
        TableHeadWithSort
    },
    data () {
        return {
        }
    },
    methods: {
        feeTableClicked(data) {
            this.$emit('feeTableClicked', data);
        },
        removeFee(fee){

            this.$store.dispatch('confirmAction', {question: this.$t('QUESTIONS.removeFee'),
                callback: (decision = false) => {
                    if(decision === true) {
                        this.$emit("addFunctionToSave", {id: `${new Date().getTime()}-fee-remove-${fee.id}-1`, run: () => {
                            this.$store.dispatch('deleteFee', fee.id);
                        }})
                        this.$emit('saveFunctions')
                    }
                }
            })
        },
        activateFee(fee){
            const acState = {...fee};
            this.$emit("addFunctionToSave", {id: `${new Date().getTime()}-fee-update-${fee.id}-1`, run: () => {
                this.$store.dispatch('updateFee', acState);
            }})
            this.$emit("addFunctionToSave", {id: `${new Date().getTime()}-fee-update-${fee.id}-2`, run: () => {
                this.$store.dispatch('getFees');
            }})
            this.$emit('saveFunctions')
        }
    },
    props: {
        fees: {
            type: Array,
            default: () => [],
        },
        history: {
            type: Boolean,
            default: false
        },
        decimalSeparator: {
            default: '.'
        },
        separator: {default: ','},
        symbol: {default: 'EUR'},
        fractionalDigits: {default: 2}
    }
}
</script>
